var _path, _g, _path2, _path3, _g2, _path4, _g3, _path5, _path6, _g4, _path7, _g5, _path8, _path9, _g6, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 84,
    viewBox: "0 0 118 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.45 76.9001C50.3716 76.9001 64.9 62.3717 64.9 44.45C64.9 26.5284 50.3716 12 32.45 12C14.5284 12 0 26.5284 0 44.45C0 62.3717 14.5284 76.9001 32.45 76.9001Z",
    fill: "#FFD880"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2597_12864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7305 48.7747C62.1244 33.912 52.0165 19.9228 37.1538 17.5288C22.2912 15.1349 8.30208 25.2428 5.90821 40.1054C3.51435 54.968 13.6223 68.9573 28.4849 71.3512C43.3475 73.7452 57.3366 63.6373 59.7305 48.7747Z",
    fill: "#D29400"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.927 65.0519C52.1623 60.3312 57.4436 47.3963 52.723 36.161C48.0025 24.9256 35.0678 19.6444 23.8325 24.3651C12.5973 29.0857 7.31599 42.0207 12.0365 53.256C16.757 64.4913 29.6917 69.7726 40.927 65.0519Z",
    fill: "#FFCA2D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2597_12864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 22,
    width: 45,
    height: 45
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9326 65.0495C52.1679 60.3288 57.4492 47.3939 52.7287 36.1585C48.0081 24.9232 35.0734 19.642 23.8381 24.3626C12.6029 29.0833 7.3216 42.0182 12.0421 53.2536C16.7626 64.4889 29.6973 69.7701 40.9326 65.0495Z",
    fill: "#FFCA2D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2597_12864)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2597_12864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1745 42.5019C20.1745 49.2541 25.8241 54.74 32.613 54.8329H57.1157V49.1016H33.1386C29.4134 49.1016 25.9558 46.1079 25.9558 42.4151C25.9558 38.7222 28.9754 35.7285 32.7006 35.7285C36.4258 35.7285 39.4454 38.7222 39.4454 42.4151C39.4454 44.9088 38.0685 47.0837 36.0272 48.2332H43.6291C44.5372 46.5209 45.0515 44.5709 45.0515 42.5019C45.0515 35.6917 39.4827 30.1709 32.613 30.1709C25.7433 30.1709 20.1745 35.6917 20.1745 42.5019Z",
    fill: "#D29400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8961 49.1016C22.2713 51.6941 24.5502 53.7418 27.318 54.8329H7.79175V49.1016H20.8961Z",
    fill: "#D29400"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6398 76.7171C109.33 72.6966 114.737 60.7709 110.717 50.0805C106.696 39.39 94.7707 33.9829 84.0802 38.0034C73.3897 42.0239 67.9827 53.9496 72.0032 64.6401C76.0237 75.3306 87.9493 80.7376 98.6398 76.7171Z",
    fill: "#FFD880"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2597_12864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.603 53.8202C106.697 44.4174 97.5292 38.3402 88.1264 40.2465C78.7236 42.1527 72.6465 51.3205 74.5527 60.7233C76.459 70.1261 85.6269 76.2032 95.0297 74.297C104.432 72.3907 110.51 63.223 108.603 53.8202Z",
    fill: "#D29400"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.039 67.7478C106.681 62.4114 106.93 53.5108 101.594 47.8677C96.2573 42.2247 87.3568 41.9762 81.7138 47.3126C76.0709 52.6491 75.8223 61.5497 81.1587 67.1927C86.4951 72.8357 95.3956 73.0843 101.039 67.7478Z",
    fill: "#FFCA2D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2597_12864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 43,
    width: 29,
    height: 29
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.041 67.7444C106.684 62.408 106.932 53.5074 101.596 47.8643C96.2597 42.2213 87.3592 41.9727 81.7163 47.3092C76.0733 52.6456 75.8248 61.5463 81.1611 67.1893C86.4975 72.8323 95.398 73.0809 101.041 67.7444Z",
    fill: "#FFCA2D"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2597_12864)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_2597_12864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6003 58.9517C85.1151 62.9795 89.7158 64.9845 93.7864 63.5169L108.403 58.0199L107.117 54.6011L92.8141 59.9801C90.592 60.8158 87.8579 59.8058 87.0294 57.6029C86.201 55.4001 87.3306 52.9369 89.5528 52.1012C91.7749 51.2655 94.2477 52.3738 95.0762 54.5767C95.6356 56.0642 95.3022 57.6705 94.3424 58.8141L98.877 57.1087C99.0346 55.8835 98.9039 54.605 98.4398 53.3708C96.912 49.3084 92.3516 47.2645 88.2537 48.8056C84.1558 50.3468 82.0725 54.8893 83.6003 58.9517Z",
    fill: "#D29400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5113 62.7266C86.9133 63.9646 88.732 64.6748 90.6278 64.7047L78.9802 69.0852L77.6944 65.6664L85.5113 62.7266Z",
    fill: "#D29400"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7739 32.0733C81.3811 34.5727 89.574 30.432 92.0733 22.8249C94.5727 15.2178 90.4321 7.02485 82.8249 4.52549C75.2178 2.02613 67.0249 6.1668 64.5255 13.7739C62.0262 21.381 66.1668 29.574 73.7739 32.0733Z",
    fill: "#FFD880"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_2597_12864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2757 23.9398C92.3646 17.9649 90.0251 10.6173 84.0503 7.52845C78.0755 4.43955 70.7279 6.77906 67.639 12.7539C64.5502 18.7287 66.8897 26.0763 72.8645 29.1652C78.8393 32.2541 86.1869 29.9146 89.2757 23.9398Z",
    fill: "#D29400"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0246 28.2264C84.4519 27.7895 88.4976 23.0356 88.0608 17.6083C87.6239 12.1809 82.8701 8.13536 77.4428 8.57224C72.0154 9.00912 67.9698 13.763 68.4066 19.1904C68.8434 24.6177 73.5973 28.6633 79.0246 28.2264Z",
    fill: "#FFCA2D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2597_12864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 8,
    width: 21,
    height: 21
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.027 28.2254C84.4544 27.7885 88.5 23.0346 88.0632 17.6073C87.6264 12.18 82.8726 8.13439 77.4452 8.57127C72.0179 9.00814 67.9723 13.762 68.4091 19.1894C68.8459 24.6167 73.5997 28.6623 79.027 28.2254Z",
    fill: "#FFCA2D"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2597_12864)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_2597_12864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.3603 15.7603C72.4187 18.6264 74.0516 21.7429 76.9204 22.7291L87.3209 26.1462L88.1202 23.7135L77.9427 20.3696C76.3615 19.8501 75.3114 18.0972 75.8264 16.5297C76.3414 14.9622 78.0406 14.1126 79.6219 14.6321C81.2031 15.1517 82.0673 16.8435 81.5523 18.411C81.2045 19.4695 80.3168 20.2006 79.29 20.4039L82.5167 21.4641C83.141 20.8639 83.6312 20.1079 83.9198 19.2297C84.8695 16.339 83.2757 13.219 80.3598 12.2609C77.4438 11.3028 74.3101 12.8696 73.3603 15.7603Z",
    fill: "#D29400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7463 18.6623C72.9684 19.9545 73.6501 21.1415 74.6728 21.9906L66.3846 19.2675L67.1839 16.8348L72.7463 18.6623Z",
    fill: "#D29400"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.908 29.9854C109.658 29.9842 109.411 29.9348 109.18 29.8399L108.497 29.5781C108.085 29.423 107.653 29.2581 107.192 29.069C106.737 29.2581 106.305 29.423 105.888 29.5781L105.19 29.8496C104.964 29.9371 104.724 29.9815 104.482 29.9806C104.212 29.9832 103.943 29.9314 103.694 29.8281C103.444 29.7248 103.217 29.5721 103.027 29.3793C102.866 29.2196 102.74 29.0281 102.656 28.8169C102.573 28.6057 102.534 28.3795 102.543 28.1526C102.572 27.498 102.62 26.7513 102.703 25.9416C102.206 25.3586 101.745 24.7466 101.321 24.1087C101.154 23.8409 101.048 23.5389 101.013 23.2251C100.978 22.9113 101.013 22.5936 101.117 22.2953C101.195 22.045 101.33 21.816 101.511 21.626C101.691 21.436 101.913 21.2901 102.16 21.1995C102.894 20.9665 103.642 20.777 104.4 20.6322C104.78 19.945 105.212 19.2885 105.694 18.6684C105.882 18.4609 106.11 18.2944 106.365 18.1794C106.62 18.0643 106.896 18.0033 107.175 18.0001C107.455 17.9969 107.732 18.0517 107.99 18.1608C108.247 18.27 108.479 18.4313 108.671 18.6345C109.162 19.265 109.603 19.933 109.99 20.6322C110.743 20.7765 111.486 20.9659 112.216 21.1995C112.464 21.2906 112.689 21.4371 112.873 21.6277C113.057 21.8184 113.195 22.0483 113.278 22.3002C113.381 22.5973 113.418 22.914 113.383 23.227C113.349 23.5399 113.245 23.8412 113.079 24.1087C112.632 24.7537 112.146 25.3707 111.624 25.9561C111.707 26.7658 111.755 27.5126 111.784 28.1671C111.794 28.3941 111.755 28.6206 111.672 28.8319C111.588 29.0432 111.461 29.2347 111.299 29.3939C111.11 29.5873 110.884 29.7407 110.634 29.8448C110.384 29.949 110.115 30.0017 109.845 30L109.908 29.9854Z",
    fill: "#D29400"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.152 23.498C112.215 23.3987 112.257 23.2877 112.277 23.1717C112.297 23.0557 112.293 22.937 112.266 22.8224C112.24 22.7078 112.191 22.5996 112.122 22.5042C112.053 22.4087 111.966 22.3279 111.866 22.2665C111.15 22.0416 110.421 21.8586 109.684 21.7186C109.56 21.6949 109.443 21.6445 109.341 21.5708C109.238 21.4971 109.154 21.4019 109.092 21.2919C108.726 20.615 108.309 19.9667 107.846 19.3524C107.669 19.1982 107.443 19.1133 107.208 19.1133C106.974 19.1133 106.747 19.1982 106.571 19.3524C106.107 19.9667 105.691 20.615 105.325 21.2919C105.263 21.4005 105.178 21.4947 105.077 21.5683C104.976 21.6418 104.86 21.6931 104.738 21.7186C103.994 21.8558 103.259 22.0388 102.537 22.2665C102.11 22.4168 102.008 23.115 102.256 23.498C102.68 24.12 103.143 24.7143 103.642 25.2775C103.724 25.3692 103.786 25.4768 103.825 25.5936C103.863 25.7105 103.877 25.8339 103.865 25.9564C103.778 26.7806 103.725 27.537 103.696 28.2013C103.671 28.6862 104.336 29.0062 104.801 28.8171C105.436 28.565 106.115 28.3322 106.862 28.0122C107.085 27.9268 107.332 27.9268 107.555 28.0122C108.302 28.3225 108.981 28.565 109.616 28.8171C110.101 29.0062 110.746 28.7056 110.721 28.2013C110.692 27.537 110.639 26.7806 110.552 25.9564C110.541 25.834 110.556 25.7109 110.594 25.5943C110.633 25.4777 110.694 25.37 110.775 25.2775C111.272 24.7148 111.732 24.1204 112.152 23.498Z",
    fill: "#FFD880"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2597_12864",
    x: 5.55737,
    y: 17.1777,
    width: 54.5239,
    height: 55.3049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.780447
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.644656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2597_12864"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2597_12864",
    x: 7.79175,
    y: 30.1709,
    width: 49.324,
    height: 25.4426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.780447
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.644656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2597_12864"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2597_12864",
    x: 74.2029,
    y: 39.8965,
    width: 34.7502,
    height: 35.2474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.497382
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.410841
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2597_12864"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_2597_12864",
    x: 77.6943,
    y: 48.292,
    width: 30.7083,
    height: 21.2908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.497382
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.410841
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2597_12864"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_2597_12864",
    x: 66.2764,
    y: 6.16553,
    width: 24.3621,
    height: 24.711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.348695
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.288025
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2597_12864"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_2597_12864",
    x: 66.3845,
    y: 11.9795,
    width: 21.7356,
    height: 14.5157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.348695
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.288025
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2597_12864"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.1063460690eef2dc10e70160368b422f.svg";
export { ForwardRef as ReactComponent };